import React from 'react'
import { Title, Description } from './ProfileModal.styles'
import {
  Circle1,
  Circle2,
  Circle3,
  ImageWrapper,
  ContentContainer,
} from './IntroductionStep.styles'

import CommunityImageSrc from '@sketch/icons/community-illustration@1x.png'
import CommunityRetinaImageSrc from '@sketch/icons/community-illustration@2x.png'
import { Image } from '@sketch/components'

export const IntroductionStep = () => {
  return (
    <>
      <ImageWrapper>
        <Image
          alt="Community"
          src={CommunityImageSrc}
          srcSet={`${CommunityRetinaImageSrc} 2x`}
        />
        <Circle1 />
        <Circle2 />
        <Circle3 />
      </ImageWrapper>
      <ContentContainer>
        <Title>Create Your Public Profile</Title>
        <Description>
          Show the world what you do best with a public profile — your space to
          share Documents, Libraries, and Templates with the rest of the design
          community.
        </Description>
      </ContentContainer>
    </>
  )
}
